import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaSun, FaMoon, FaDiscord, FaFilePdf } from 'react-icons/fa6';
import { GraduationCap, CalendarDays, MapPin } from "lucide-react";

export default function Portfolio() {
  const [darkMode, setDarkMode] = useState(true);

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <div style={{
      backgroundColor: darkMode ? '#000' : '#fff',
      color: darkMode ? '#fff' : '#000',
      fontFamily: 'Poppins, sans-serif',
      transition: 'background-color 0.3s, color 0.3s'
    }}>
      <header style={{
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: darkMode ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(6px)',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
      }}>
        <div></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <a href="mailto:marcus.moquin@hotmail.com" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaEnvelope /></a>
          <a href="https://github.com/mrcsm" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaGithub /></a>
          <a href="https://linkedin.com/in/marcusmoquin" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaLinkedin /></a>
          <a href="https://discord.com/users/274734101821390856" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaDiscord /></a>
          <a href="/resume.pdf" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaFilePdf /></a>
          <button onClick={toggleTheme} style={{ padding: '0.5rem', background: '#fb923c', borderRadius: '0.75rem', color: '#fff', border: 'none', fontSize: '1.25rem', cursor: 'pointer' }}>
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </div>
      </header>

      <main style={{ padding: '2rem 1.5rem', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Hero Section */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            textAlign: 'center',
            paddingTop: '13rem',
            minHeight: '70vh'
          }}
        >
          <img
            src="/profile.jpg"
            alt="Profile"
            style={{
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginBottom: '1rem',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)'
            }}
          />
          <h2 style={{ fontSize: '3rem', fontWeight: '800', color: '#fb923c', margin: 0 }}>
            Marcus Moquin
          </h2>
          <p style={{ margin: '4px 0 0 0', fontSize: '1.25rem' }}>
            23yo Computer Science Graduate
          </p>
        </motion.section>

        {/* About Section */}
        <motion.section
          id="about"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="mb-24"
        >
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fb923c', marginBottom: '1rem' }}>Education</h3>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/algonquin.png" alt="Algonquin Logo" style={{ width: '70px', height: '70px' }} />
            <div style={{ lineHeight: 1.2 }}>
              <p style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '3px' }}>Algonquin College - Online</p>
              <p style={{ fontSize: '15px', color: 'white', marginTop: '4px', marginBottom: '4px' }}>Computer Programming</p>
              <p style={{ fontSize: '14px', color: 'white', marginTop: '1px' }}>Currently Attending</p>
            </div>
          </div>

          <div className="mt-3 text-sm text-white space-y-1">
            <div className="flex items-center gap-2">
              <CalendarDays className="w-4 h-4" style={{ transform: 'translateY(4px)' }} />
              <span className="flex items-center" style={{ fontWeight: 'bold' }}> Sept. 2025 — Jan. 2027</span>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4" style={{ transform: 'translateY(4px)' }} />
              <span className="flex items-center" style={{ fontWeight: 'bold' }}> Ottawa, Ontario</span>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/carleton-logo.png" alt="Carleton Logo" style={{ width: '70px', height: '70px' }} />
            <div style={{ lineHeight: 1.2 }}>
              <p style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '3px' }}>Carleton University</p>
              <p style={{ fontSize: '15px', color: 'white', marginTop: '4px', marginBottom: '4px' }}>Bachelor of Computer Science Honours</p>
              <p style={{ fontSize: '14px', color: 'white', marginTop: '1px' }}>Graduated with High Distinction</p>
            </div>
          </div>

          <div className="mt-3 text-sm text-white space-y-1">
            <div className="flex items-center gap-2">
              <GraduationCap className="w-4 h-4" style={{ transform: 'translateY(4px)' }} />
              <span className="flex items-center" style={{ fontWeight: 'bold' }}> GPA: 10.91/12</span>
            </div>
            <div className="flex items-center gap-2">
              <CalendarDays className="w-4 h-4" style={{ transform: 'translateY(4px)' }} />
              <span className="flex items-center" style={{ fontWeight: 'bold' }}> Sept. 2020 — Dec. 2024</span>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4" style={{ transform: 'translateY(4px)' }} />
              <span className="flex items-center" style={{ fontWeight: 'bold' }}> Ottawa, Ontario</span>
            </div>
          </div>
        </motion.section>

        {/* Experience Section */}
        <motion.section id="experience" initial={{ y: 100, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8 }} style={{ marginBottom: '6rem' }}>
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fb923c', marginBottom: '2rem' }}>Experience</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/hoplite.jpg"
                alt="Hoplite Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  Minecraft Plugin Developer @ Hoplite
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  September 2025 - Present
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Assisting in plugin development for several minigames on the network.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Working remotely with a team of developers on minigames played by over 1 million unique players.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Utilizing Git/GitLab for version control, Notion for task management, and Slack for team communication.
                </p>
              </div>
            </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/hoplite.jpg"
                alt="Hoplite Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  Volunteer Quality Assurance Game Tester @ Hoplite
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  March 2025 - September 2025
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Identifying, reproducing, and reporting bugs encountered while testing the network's minigames on ClickUp/Notion
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Providing feedback on gameplay, mechanics, and overall user experience
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Handling bug reports and technical support tickets submitted by players through the network's Discord server
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/arctic.jpg"
                alt="Arctic Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  Minecraft Java Developer @ ArcticMC
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  May 2023 - Present
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Assisting in Java development for several minigames on a Minecraft network
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Contributing to feature addition, bug fixing, and code debugging to the network.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Working with lead developer to adapt the codebase for internationalization (I18n)
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Developed ticket and logging systems for the network's Discord bot utilizing Discord4J and gRPC
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Utilizing Git, GitHub, and Discord for developer collaboration, communication, and issue tracking
                </p>
              </div>
            </div>
        
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/dell.jpg"
                alt="Dell Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  5G Test and Automation Intern @ Dell Technologies
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  September 2022 - December 2022
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Worked in a team to develop a test strategy for the 5G RAN
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Researched and presented several frameworks to integrate C code into Python
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Assisted in modifying test cases utilizing the Robot Framework
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Refactored code base using autopep8 linter to comply with PEP 8 coding standards
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Used Sphinx and AutoDoc to generate documentation for the code base
                </p>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Projects Section */}
        <motion.section id="projects" initial={{ x: 100, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} transition={{ duration: 0.8 }} style={{ marginBottom: '6rem' }}>
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fb923c', marginBottom: '1rem' }}>Projects</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={{ padding: '0.75rem', backgroundColor: '#fed7aa', color: '#000', borderRadius: '1rem', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', transition: 'transform 0.3s' }}>
              <h4 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', marginTop: '0rem' }}>AED Plus System Simulator</h4>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>● A simplified software simulation of the AED Plus device using Qt C++.</p>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● Group of 4 Project done for COMP3004: Object Oriented Software Engineering at Carleton University</p>
              <a href="https://github.com/MrcsM/COMP3004FinalProject" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '0.95rem' }}><FaGithub />Click to view</a>
            </div>
          </div>
        </motion.section>

        {/* Skills Section */}
        <motion.section
          id="skills"
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '6rem' }}
        >
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fb923c', marginBottom: '1rem' }}>
            Skills
          </h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
              <strong style={{ fontSize: '1.1rem' }}>Programming Languages</strong>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Java</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Python</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Kotlin</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>C</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>C++</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>JavaScript</span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
              <strong style={{ fontSize: '1.1rem' }}>Developer Tools</strong>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Git</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>GitHub</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Visual Studio Code</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>IntelliJ IDEA</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Jira</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Confluence</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>ClickUp</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>MongoDB</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Discord4J</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>gRPC</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>jOOQ</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>Robot Framework</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>NodeJS</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>ExpressJS</span>
              <span style={{ padding: '0.5rem 1rem', backgroundColor: '#fdba74', color: '#000', borderRadius: '999px' }}>autopep8</span>
            </div>
          </div>
        </motion.section>
      </main>

      <footer style={{ textAlign: 'center', padding: '2rem 0', fontSize: '0.875rem', opacity: 0.7 }}>
        &copy; {new Date().getFullYear()} Marcus Moquin. All rights reserved.
      </footer>
    </div>
  );
}
